<template>
    <BaseTemplate app-name="Pendências" page-title="">
        <template #content>
            <div class="min-h-screen bg-slate-200 dark:bg-gray-900 px-4 md:px-8 py-4">
            <!-- Modal Criar Pendência -->
            <transition name="modal">
                <div v-if="modalCriarPendencia"
                    class="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-0 sm:p-4 dark:bg-black/80"
                    style="min-height: 100vh; min-width: 100vw;"
                    @click.self="fecharModalCriarPendencia">
                    <div class="relative bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-xs sm:max-w-md md:max-w-lg animate-fade-in flex flex-col max-h-[75vh] sm:max-h-[85vh] p-2 sm:p-4 text-sm sm:text-base">
                        <!-- Cabeçalho fixo -->
                        <div class="sticky top-0 z-10 flex items-center justify-between px-2 py-2 sm:px-4 sm:py-3 border-b border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800 rounded-t-2xl">
                            <h3 class="text-lg sm:text-2xl font-bold text-gray-800 dark:text-white">Criar Nova Pendência</h3>
                            <button @click="fecharModalCriarPendencia" class="text-gray-600 dark:text-gray-300 hover:text-red-500 transition-all rounded-full p-1.5 focus:outline-none focus:ring-2 focus:ring-red-400">
                                <span class="sr-only">Fechar</span>
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
                            </button>
                        </div>
                        <!-- Corpo do formulário com rolagem -->
                        <div class="overflow-y-auto px-1 py-2 sm:px-4 sm:py-6 flex-1 scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-700">
                            <form @submit.prevent="criarPendencia" class="space-y-4 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-6">
                                <!-- Grupo Unidade/Setor -->
                                <div class="sm:col-span-2 flex flex-col sm:flex-row gap-4">
                                    <div class="flex-1">
                                        <label class="block text-base font-semibold text-gray-700 dark:text-gray-200 mb-2">Unidade</label>
                                        <select v-model="novaPendencia.unidade_id" @change="filtrarSetores" required class="w-full p-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg dark:text-white text-sm">
                                            <option value="">Selecione</option>
                                            <option v-for="unidade in unidades" :key="unidade.id" :value="unidade.id">{{ unidade.nome }}</option>
                                        </select>
                                    </div>
                                    <div class="flex-1">
                                        <label class="block text-base font-semibold text-gray-700 dark:text-gray-200 mb-2">Setor</label>
                                        <select v-model="novaPendencia.setor_id" :disabled="!novaPendencia.unidade_id" class="w-full p-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg dark:text-white text-sm">
                                            <option value="">Selecione</option>
                                            <option v-for="setor in setoresFiltrados" :key="setor.id" :value="setor.id">{{ setor.nome }}</option>
                                        </select>
                                    </div>
                                </div>
                                <hr class="my-2 sm:my-3 border-gray-200 dark:border-gray-700" />
                                <!-- Grupo Tipo/Status -->
                                <div class="sm:col-span-2 flex flex-col sm:flex-row gap-4">
                                    <div class="flex-1">
                                        <label class="block text-base font-semibold text-gray-700 dark:text-gray-200 mb-2">Tipo de Pendência</label>
                                        <select v-model="novaPendencia.tipo_id" required class="w-full p-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg dark:text-white text-sm">
                                            <option value="">Selecione</option>
                                            <option v-for="tipo in tiposPendencias" :key="tipo.id" :value="tipo.id">{{ tipo.nome }}</option>
                                        </select>
                                    </div>
                                    <div class="flex-1">
                                        <label class="block text-base font-semibold text-gray-700 dark:text-gray-200 mb-2">Status</label>
                                                                    <select 
                                v-model="novaPendencia.status" 
                                :disabled="!novaPendencia.tipo_id"
                                required 
                                class="w-full p-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg dark:text-white text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                <option value="">{{ !novaPendencia.tipo_id ? 'Selecione um tipo primeiro' : 'Selecione um status' }}</option>
                                <option v-for="status in statusDisponiveis" :key="status.id" :value="status.id">
                                    {{ status.nome }}
                                </option>
                            </select>
                                    </div>
                                </div>
                                <hr class="my-2 sm:my-3 border-gray-200 dark:border-gray-700" />
                                <!-- Grupo Responsáveis -->
                                <div class="sm:col-span-2 flex flex-col sm:flex-row gap-4">
                                    <div class="flex-1">
                                        <label class="block text-base font-semibold text-gray-700 dark:text-gray-200 mb-2">Responsável Interno (Opcional)</label>
                                        <select v-model="novaPendencia.responsavel_interno_id" class="w-full p-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg dark:text-white text-sm">
                                            <option value="">Nenhum</option>
                                            <option v-for="resp in responsaveisInternos" :key="resp.id" :value="resp.id">{{ resp.nome_completo }}</option>
                                        </select>
                                    </div>
                                    <div class="flex-1">
                                        <label class="block text-base font-semibold text-gray-700 dark:text-gray-200 mb-2">Responsável Externo (Opcional)</label>
                                        <select v-model.number="novaPendencia.responsavel_externo_id" class="w-full p-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg dark:text-white text-sm">
                                            <option value="">Nenhum</option>
                                            <option v-for="fornecedor in fornecedores" :key="fornecedor.id" :value="Number(fornecedor.id)">{{ fornecedor.nome }}</option>
                                        </select>
                                    </div>
                                </div>
                                <hr class="my-2 sm:my-3 border-gray-200 dark:border-gray-700" />
                                <!-- Problema -->
                                <div class="sm:col-span-2">
                                    <label class="block text-base font-semibold text-gray-700 dark:text-gray-200 mb-2">Problema</label>
                                    <textarea v-model="novaPendencia.problema" required placeholder="Digite o problema em poucas palavras" class="w-full p-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg dark:text-white min-h-[90px] text-sm"></textarea>
                                </div>
                                <hr class="my-2 sm:my-3 border-gray-200 dark:border-gray-700" />
                                <!-- Grupo Prazo/Prioridade -->
                                <div class="sm:col-span-2 flex flex-col sm:flex-row gap-4">
                                    <div class="flex-1">
                                        <label class="block text-base font-semibold text-gray-700 dark:text-gray-200 mb-2">Prazo</label>
                                        <div class="flex gap-3">
                                            <select v-model="novaPendencia.prazoPeriodo" @change="calcularPrazo" required class="w-1/2 p-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg dark:text-white text-sm">
                                                <option value="">Selecione um período</option>
                                                <option value="7">7 dias</option>
                                                <option value="15">15 dias</option>
                                                <option value="30">30 dias</option>
                                                <option value="60">60 dias</option>
                                                <option value="180">6 meses</option>
                                                <option value="365">1 ano</option>
                                            </select>
                                            <input type="date" v-model="novaPendencia.prazo" required class="w-1/2 p-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg dark:text-white text-sm" />
                                        </div>
                                    </div>
                                    <div class="flex-1">
                                        <label class="block text-base font-semibold text-gray-700 dark:text-gray-200 mb-2">Prioridade</label>
                                        <select v-model="novaPendencia.prioridade" required class="w-full p-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg dark:text-white text-sm">
                                            <option value="baixa">Baixa</option>
                                            <option value="media">Média</option>
                                            <option value="alta">Alta</option>
                                            <option value="critica">Crítica</option>
                                        </select>
                                    </div>
                                </div>
                                <!-- Actions -->
                                <div class="flex flex-col sm:flex-row-reverse gap-2 sm:gap-4 mt-6 w-full sm:justify-end">
                                    <button type="button" @click="fecharModalCriarPendencia" class="w-full sm:w-auto px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 font-semibold hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors text-base sm:text-sm">Cancelar</button>
                                    <button type="submit" :disabled="!isFormValid" class="w-full sm:w-auto px-4 py-2 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-base sm:text-sm whitespace-nowrap">Criar Pendência</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </transition>
            <div class="w-full py-4">

                <!-- Loader -->
                <div v-if="isLoading" class="flex flex-col items-center justify-center min-h-screen">
                    <RefreshCw class="h-16 w-16 animate-spin text-blue-600 dark:text-blue-400 mx-auto" />
                </div>
                
                <!-- Sem pendências (apenas quando não há nenhuma pendência cadastrada no sistema) -->
                <div v-if="!isLoading && (!pendencias || pendencias.length === 0) && (!pendenciasFiltradas || pendenciasFiltradas.length === 0) && !temFiltrosAtivos" 
                     class="flex flex-col items-center justify-center min-h-[60vh] text-center text-gray-600 dark:text-gray-300 gap-6">
                    <p class="text-xl font-semibold">{{ mensagemSemPendencias }}</p>
                    <button
                        v-if="podeCriarPendencia"
                        @click="abrirModalCriarPendencia"
                        class="flex items-center justify-center gap-2 px-6 py-2.5 rounded-xl shadow-md bg-blue-600 text-white hover:bg-blue-700 w-full sm:w-auto focus:outline-none focus:ring-2 focus:ring-blue-300 font-medium">
                        <PlusCircle class="w-5 h-5" />
                        <span>Nova Pendência</span>
                    </button>
                </div>
                
                <!-- Conteúdo principal -->
                <div v-if="!isLoading">
                    <!-- Header com título e botões principais -->
                    <div class="flex flex-col gap-5 mb-8">
                        <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                            <div class="flex items-center gap-3">
                                <h2 class="text-2xl sm:text-3xl font-bold text-gray-800 dark:text-white tracking-tight">
                                    Lista de Pendências
                                </h2>
                                
                                <Transition name="fade-scale">
                                    <span v-if="!exibirKanban"
                                        class="bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 text-xs font-semibold px-3 py-1 rounded-full flex items-center justify-center min-w-[72px]">
                                        {{ totalItems }} itens
                                    </span>
                                </Transition>
                            </div>

                            <!-- Barra de ações reorganizada -->
                            <div class="flex flex-wrap gap-3 w-full sm:w-auto">
                                <!-- Grupo de botões principais -->
                                <div class="flex flex-wrap gap-3 w-full sm:w-auto">
                                    <!-- Botão Nova Pendência (visível apenas para superadmin e direcao) -->
                                    <button
                                        v-if="podeCriarPendencia"
                                        @click="abrirModalCriarPendencia"
                                        class="flex items-center justify-center gap-2 px-6 py-2.5 rounded-xl shadow-md bg-blue-600 text-white hover:bg-blue-700 w-full sm:w-auto focus:outline-none focus:ring-2 focus:ring-blue-300 font-medium"
                                    >
                                        <PlusCircle class="w-5 h-5" />
                                        <span>Nova Pendência</span>
                                    </button>
                                    
                                    <!-- Botão de alternar visualização (sempre visível) -->
                                    <button
                                        @click="irParaKanban"
                                        class="flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl shadow-md bg-gradient-to-r from-purple-600 to-indigo-600 text-white hover:from-purple-700 hover:to-indigo-700 transition-all duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-purple-400 w-full sm:w-auto"
                                    >
                                        <component :is="exibirKanban ? List : SquareKanban" class="w-5 h-5" />
                                        <span class="font-semibold tracking-wide">
                                            {{ exibirKanban ? 'Ver Lista' : 'Kanban' }}
                                        </span>
                                    </button>
                                    
                                    <!-- Botões visíveis apenas na visualização de lista -->
                                    <transition name="slide-down">
                                        <div v-if="!exibirKanban" class="flex flex-wrap gap-3 w-full sm:w-auto">
                                            <!-- Botão de Filtro -->
                                            <button
                                                @click="abrirModalFiltro"
                                                class="relative flex items-center justify-center gap-2 px-4 py-2.5 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-all duration-200 focus:ring-2 focus:ring-gray-400 focus:outline-none shadow-md w-full sm:w-auto"
                                            >
                                                <Filter class="w-5 h-5" />
                                                <span class="font-medium">Filtros</span>
                                                <span
                                                    v-if="totalFiltros > 0"
                                                    class="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center animate-pulse"
                                                >
                                                    {{ totalFiltros }}
                                                </span>
                                            </button>
                                        </div>
                                    </transition>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Barra de pesquisa (visível apenas na visualização de lista) -->
                        <transition name="slide-down">
                            <div v-if="!exibirKanban" class="flex flex-col sm:flex-row gap-4">
                                <!-- Campo de busca -->
                                <div class="relative w-full sm:w-72">
                                    <input
                                        v-model="filtroProblema"
                                        @keyup.enter="buscarProblema"
                                        @input="onInputProblema"
                                        type="text"
                                        placeholder="Buscar por problema..."
                                        class="pl-10 pr-4 py-2.5 w-full border rounded-lg text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:outline-none"
                                    />
                                    <button @click="buscarProblema" class="absolute right-2 top-2  bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded-md text-sm font-semibold transition-all">
                                        Buscar
                                    </button>
                                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 text-gray-400">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                                        </svg>
                                    </div>
                                </div>
                                
                                <!-- Checkboxes para mostrar concluídos/cancelados -->
                                <div class="flex flex-wrap items-center gap-6">
                                    <label class="flex items-center gap-2 cursor-pointer group">
                                        <div class="relative">
                                            <input type="checkbox" v-model="mostrarConcluidos" class="peer sr-only" />
                                            <div class="w-5 h-5 border-2 border-gray-300 dark:border-gray-600 rounded-md peer-checked:bg-blue-500 peer-checked:border-blue-500 transition-all duration-200"></div>
                                            <div class="absolute top-[2px] left-[2px] w-4 h-4 text-white opacity-0 peer-checked:opacity-100 pointer-events-none transition-opacity duration-200">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                                                </svg>
                                            </div>
                                        </div>
                                        <span class="text-sm text-gray-700 dark:text-gray-300 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors duration-200">
                                            Mostrar Concluídos
                                        </span>
                                    </label>

                                    <label class="flex items-center gap-2 cursor-pointer group">
                                        <div class="relative">
                                            <input type="checkbox" v-model="mostrarExcluidos" class="peer sr-only" />
                                            <div class="w-5 h-5 border-2 border-gray-300 dark:border-gray-600 rounded-md peer-checked:bg-blue-500 peer-checked:border-blue-500 transition-all duration-200"></div>
                                            <div class="absolute top-[2px] left-[2px] w-4 h-4 text-white opacity-0 peer-checked:opacity-100 pointer-events-none transition-opacity duration-200">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                                                </svg>
                                            </div>
                                        </div>
                                        <span class="text-sm text-gray-700 dark:text-gray-300 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors duration-200">
                                            Mostrar Cancelados
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </transition>
                    </div>
                    
                    <!-- Toast de Sucesso -->
                    <div v-if="mensagemSucesso"
                        class="fixed top-5 right-5 bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg animate-fade-in">
                        {{ mensagemSucesso }}
                    </div>

                    <!-- Sem resultados após filtro -->
                    <div v-if="pendenciasFiltradas.length === 0" class="flex items-center justify-center min-h-[60vh] text-center text-gray-600 dark:text-gray-300">
                        <p class="text-xl font-semibold">
                            Nenhuma pendência encontrada com os filtros aplicados.
                            <br>
                            <span class="text-base font-normal">
                                Se desejar visualizar pendências concluídas ou canceladas, ative as opções "Mostrar Concluídos" e "Mostrar Cancelados".
                            </span>
                        </p>
                    </div>

                    

                    <!-- Conteúdo principal (Kanban ou Lista) -->
                    <template v-else>
      <div class="w-full py-2 sm:py-5">
        <div class="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3 overflow-x-auto">
          <!-- 📌 Card - Pendências -->
          <div class="rounded-lg bg-white dark:bg-gray-800 p-3 sm:p-4 shadow-md flex items-center">
            <LucideClipboardList class="text-gray-500 dark:text-gray-300 w-5 h-5 mr-2" />
            <div>
              <h3 class="text-xs sm:text-sm font-medium text-gray-600 dark:text-gray-300">
                Pendências
              </h3>
              <p class="mt-1 text-lg sm:text-xl font-bold text-gray-900 dark:text-white">
                {{ totalPendencias }}
              </p>
            </div>
          </div>

          <!-- 📌 Card - Atrasadas -->
          <div class="rounded-lg bg-white dark:bg-gray-800 p-3 sm:p-4 shadow-md flex items-center">
            <LucideAlertCircle class="text-red-500 w-5 h-5 mr-2" />
            <div>
              <h3 class="text-xs sm:text-sm font-medium text-gray-600 dark:text-gray-300">
                Atrasadas
              </h3>
              <p class="mt-1 text-lg sm:text-xl font-bold text-red-600 dark:text-red-400">
                {{ atrasadas }}
              </p>
            </div>
          </div>

          <!-- 📌 Card - Concluídas -->
          <div class="rounded-lg bg-green-100 dark:bg-green-800 p-3 sm:p-4 shadow-md flex items-center">
            <LucideCheckCircle class="text-green-500 w-5 h-5 mr-2" />
            <div>
              <h3 class="text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-200">
                Concluídas
              </h3>
              <p class="mt-1 text-lg sm:text-xl font-bold text-green-600 dark:text-green-400">
                {{ concluidas }}
              </p>
            </div>
          </div>

          <!-- 💰 Card – Orçamento -->
          <div class="rounded-lg bg-yellow-100 dark:bg-yellow-800 p-3 sm:p-4 shadow-md flex items-center">
            <Coins class="text-yellow-600 dark:text-yellow-400 w-5 h-5 mr-2" />
            <div>
              <h3 class="flex items-center text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-200">
                Orçamento Pendências
                <span title="Recursos humanos não entram na contagem" class="ml-1">
                  <InfoIcon class="w-4 h-4 dark:text-white text-gray-700" />
                </span>
              </h3>
              <p class="mt-1 text-lg sm:text-xl font-bold text-yellow-700 dark:text-yellow-300">
                {{ orcamentoTotal }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <Transition name="fade-slide" mode="out-in">
        <!-- Kanban -->
        <div v-if="exibirKanban" :key="exibirKanban">
          <!-- 📌 Passa pendenciasFiltradas como prop e escuta updateMetrics -->
          <PendenciasKanban
            :pendencias="pendenciasFiltradas"
            @updateMetrics="carregarMetricas"
          />
        </div>

                            <!-- Lista -->
                            <div v-else :key="!exibirKanban">
                                <!-- Loader só para a tabela -->
                                <div v-if="isLoading" class="flex items-center justify-center py-12">
                                    <RefreshCw class="h-16 w-16 animate-spin text-blue-600 dark:text-blue-400 mx-auto" />
                                </div>
                                <!-- Tabela (Escondida em telas pequenas) -->
                                <div v-else class="overflow-x-auto rounded-xl shadow-lg bg-white dark:bg-gray-800 hidden sm:block">
                                    <table class="w-full">
                                        <thead>
                                            <tr class="bg-blue-500 dark:bg-blue-600 text-white dark:text-gray-300 text-sm uppercase tracking-wide rounded-t-lg">
                                                <th @click="ordenarPor('codigo')" class="cursor-pointer text-left px-6 py-4 whitespace-nowrap">
                                                    Código <span v-if="colunaOrdenada === 'codigo'">{{ ordemAscendente ? '▲' : '▼' }}</span>
                                                </th>
                                                <th @click="ordenarPor('problema')" class="cursor-pointer text-left px-6 py-4 whitespace-nowrap">
                                                    Problema <span v-if="colunaOrdenada === 'problema'">{{ ordemAscendente ? '▲' : '▼' }}</span>
                                                </th>
                                                <th @click="ordenarPor('unidade.nome')" class="cursor-pointer text-left px-6 py-4 whitespace-nowrap">
                                                    Unidade <span v-if="colunaOrdenada === 'unidade.nome'">{{ ordemAscendente ? '▲' : '▼' }}</span>
                                                </th>
                                                <th @click="ordenarPor('setor__nome')" class="cursor-pointer text-left px-6 py-4 whitespace-nowrap">
                                                    Setor <span v-if="colunaOrdenada === 'setor__nome'">{{ ordemAscendente ? '▲' : '▼' }}</span>
                                                </th>
                                                <th @click="ordenarPor('status__nome')" class="cursor-pointer text-left px-6 py-4 whitespace-nowrap">
                                                    Status <span v-if="colunaOrdenada === 'status__nome'">{{ ordemAscendente ? '▲' : '▼' }}</span>
                                                </th>
                                                <th @click="ordenarPor('responsavel_interno')" class="cursor-pointer text-left px-6 py-4 whitespace-nowrap">
                                                    Interno <span v-if="colunaOrdenada === 'responsavel_interno'">{{ ordemAscendente ? '▲' : '▼' }}</span>
                                                </th>
                                                <th @click="ordenarPor('responsavel_externo')" class="cursor-pointer text-left px-6 py-4 whitespace-nowrap">
                                                    Externo <span v-if="colunaOrdenada === 'responsavel_externo'">{{ ordemAscendente ? '▲' : '▼' }}</span>
                                                </th>
                                                <th @click="ordenarPor('data_criacao')" class="cursor-pointer text-left px-6 py-4 whitespace-nowrap">
                                                    Data de Criação <span v-if="colunaOrdenada === 'data_criacao'">{{ ordemAscendente ? '▲' : '▼' }}</span>
                                                </th>
                                                <th @click="ordenarPor('prioridade')" class="cursor-pointer text-left px-6 py-4 whitespace-nowrap">
                                                    Prioridade <span v-if="colunaOrdenada === 'prioridade'">{{ ordemAscendente ? '▲' : '▼' }}</span>
                                                </th>
                                                <th class="px-6 py-4 text-sm font-semibold text-gray-200 dark:text-gray-300 text-center whitespace-nowrap">
                                                    Ações
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
                                            <tr v-if="isLoading">
                                                <td :colspan="11" class="py-12 text-center">
                                                    <RefreshCw class="h-16 w-16 animate-spin text-blue-600 dark:text-blue-400 mx-auto" />
                                                </td>
                                            </tr>
                                            <tr v-else v-for="pendencia in pendenciasPaginadas" :key="pendencia.id"
                                                class="group hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors duration-200">
                                                <td class="px-6 py-4 text-sm text-gray-800 dark:text-gray-300">{{ pendencia.codigo }}</td>
                                                <td class="px-6 py-4 text-sm text-gray-800 dark:text-gray-300">{{ pendencia.problema }}</td>
                                                <td class="px-6 py-4 text-sm text-gray-800 dark:text-gray-300">
                                                    {{ (pendencia.setor && pendencia.setor.unidade) ? pendencia.setor.unidade.nome : (pendencia.unidade ? pendencia.unidade.nome : 'Geral') }}
                                                </td>
                                                <td class="hidden md:table-cell px-6 py-4 text-sm text-gray-800 dark:text-gray-300">
                                                    {{ pendencia.setor?.nome || 'Geral' }}
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap">
                                                    <span :class="getStatusClass(pendencia.status.nome)"
                                                        class="px-3 py-1 rounded-full text-sm text-xs font-medium whitespace-nowrap">
                                                        {{ pendencia.status.nome }}
                                                    </span>
                                                </td>
                                                <td class="px-6 py-4 text-sm text-gray-800 dark:text-gray-300">{{ pendencia.responsavel_interno || "Não informado" }}</td>
                                                <td class="px-6 py-4 text-sm text-gray-800 dark:text-gray-300">{{ pendencia.responsavel_externo || "Não informado" }}</td>
                                                <td class="px-6 py-4 text-sm text-gray-800 dark:text-gray-300">{{ formatarData(pendencia.data_criacao) }}</td>
                                                <td class="hidden sm:table-cell px-6 py-4">
                                                    <span :class="getPrioridadeClass(pendencia.prioridade)"
                                                        class="px-3 py-1 uppercase rounded-full text-xs font-medium">
                                                        {{ pendencia.prioridade }}
                                                    </span>
                                                </td>
                                                <td class="px-6 py-4 text-center">
                                                    <button @click="verDetalhes(pendencia.id)"
                                                        class="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300">
                                                        Ver detalhes
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                           
                                <!-- Cards no Mobile -->
                                <div class="sm:hidden space-y-6">
                                    <div v-for="pendencia in pendenciasPaginadas" :key="pendencia.id"
                                        class="bg-white dark:bg-gray-900 shadow-lg rounded-xl p-6 border border-gray-100 dark:border-gray-700 transition transform hover:scale-105">
                                        <div class="flex justify-between items-center">
                                            <h3 class="text-xl font-bold text-gray-900 dark:text-white">
                                                {{ pendencia.tipo.nome }}
                                            </h3>
                                            <span :class="getStatusClass(pendencia.status.nome)"
                                                class="px-4 py-1 rounded-full text-xs font-semibold">
                                                {{ pendencia.status.nome }}
                                            </span>
                                        </div>

                                        <div class="mt-4 space-y-2">
                                            <p class="text-sm text-gray-700 dark:text-gray-300">
                                                <span class="font-medium">Unidade:</span>
                                                {{ (pendencia.setor && pendencia.setor.unidade) ? pendencia.setor.unidade.nome : (pendencia.unidade ? pendencia.unidade.nome : 'Geral') }}
                                            </p>
                                            <p class="text-sm text-gray-700 dark:text-gray-300">
                                                <span class="font-medium">Setor:</span> {{ pendencia.setor?.nome || 'Geral' }}
                                            </p>
                                            <p class="text-sm text-gray-700 dark:text-gray-300">
                                                <span class="font-medium">Problema:</span> {{ pendencia.problema || 'Não Informado' }}
                                            </p>
                                            <p class="text-sm text-gray-700 dark:text-gray-300">
                                                <span class="font-medium">Interno:</span> {{ pendencia.responsavel_interno || 'Não Informado' }}
                                            </p>
                                            <p class="text-sm text-gray-700 dark:text-gray-300">
                                                <span class="font-medium">Externo:</span> {{ pendencia.responsavel_externo || 'Não Informado' }}
                                            </p>
                                            <p class="text-sm text-gray-700 dark:text-gray-300">
                                                <span class="font-medium">Valor:</span> {{ formatCurrency(pendencia?.orcamento) || 'Não Informado' }}
                                            </p>
                                            <p class="text-sm text-gray-700 dark:text-gray-300 flex items-center">
                                                <span class="font-medium">Prioridade:</span>
                                                <span :class="getPrioridadeClass(pendencia.prioridade)"
                                                    class="ml-2 px-3 py-1 rounded-full text-xs font-medium uppercase">
                                                    {{ pendencia.prioridade }}
                                                </span>
                                            </p>
                                            <p class="text-sm text-gray-700 dark:text-gray-300">
                                                <span class="font-medium">Data de Criação:</span> {{ formatarData(pendencia.data_criacao) }}
                                            </p>
                                        </div>

                                        <button @click="verDetalhes(pendencia.id)"
                                            class="mt-6 w-full bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold py-2 rounded-md shadow">
                                            Ver detalhes
                                        </button>
                                    </div>
                                </div>
                                
                                <!-- Paginação no estilo solicitado -->
                                <div class="flex flex-col md:flex-row md:items-center md:justify-between my-4 gap-2">
                                    <div class="flex items-center gap-2 justify-center">
                                        <button 
                                            :disabled="paginaAtual === 1" 
                                            @click="mudarPagina(paginaAtual - 1)"
                                            class="px-3 py-1 rounded bg-blue-500 dark:bg-gray-700 text-gray-200 dark:text-gray-200 disabled:opacity-50"
                                        >Anterior</button>
                                        <span class="text-sm text-gray-700 dark:text-gray-200">Página {{ paginaAtual }} de {{ totalPaginas }}</span>
                                        <button 
                                            :disabled="paginaAtual === totalPaginas" 
                                            @click="mudarPagina(paginaAtual + 1)"
                                            class="px-3 py-1 rounded bg-blue-500 dark:bg-gray-700 text-gray-200 dark:text-gray-200 disabled:opacity-50"
                                        >Próxima</button>
                                    </div>
                                    <div class="flex items-center gap-2 justify-center">
                                        <label for="page-size" class="text-sm text-gray-700 dark:text-gray-200">Itens por página:</label>
                                        <select id="page-size" :value="itensPorPagina" @change="alterarItensPorPagina(Number($event.target.value))" 
                                                class="rounded border px-2 py-1 text-sm dark:bg-gray-700 dark:text-white">
                                            <option :value="5">5</option>
                                            <option :value="10">10</option>
                                            <option :value="20">20</option>
                                            <option :value="50">50</option>
                                        </select>
                                        <span class="text-xs text-gray-500 dark:text-gray-400">Total: {{ totalItems }}</span>
                                    </div>
                                </div>
                            </div>
                        </Transition>
                    </template>

                    <!-- Modal de Filtros -->
                    <transition name="modal">
                        <div v-if="modalFiltro" class="fixed inset-0 bg-black/50 flex items-center justify-center p-4 dark:bg-black/70" @click.self="fecharModalFiltro">
                            <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-lg animate-fade-in p-6">
                                <div class="flex justify-between items-center mb-4">
                                    <h3 class="text-xl font-bold text-gray-800 dark:text-white">Filtros</h3>
                                    <button @click="fecharModalFiltro" class="text-gray-600 dark:text-gray-300 hover:text-red-500 transition-all">
                                        <i class="fas fa-times"></i>
                                    </button>
                                </div>

                                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <!-- Filtro por Status -->
                                    <div>
                                        <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Status</label>
                                        <select v-model="filtroStatus" class="w-full p-2.5 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg shadow-sm dark:text-white">
                                            <option value="">Todos</option>
                                            <option v-for="status in statusPendencias" :key="status.id" :value="status.id">
                                                {{ status.nome }}
                                            </option>
                                        </select>
                                    </div>

                                    <!-- Filtro por Unidade -->
                                    <div>
                                        <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Unidade</label>
                                        <select v-model="filtroUnidade" class="w-full p-2.5 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg shadow-sm dark:text-white">
                                            <option value="">Todas</option>
                                            <option v-for="unidade in unidades" :key="unidade.id" :value="unidade.id">
                                                {{ unidade.nome }}
                                            </option>
                                        </select>
                                    </div>

                                    <!-- Filtro por Tipo -->
                                    <div>
                                        <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Tipo de Pendência</label>
                                        <select v-model="filtroTipo" class="w-full p-2.5 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg shadow-sm dark:text-white">
                                            <option value="">Todos</option>
                                            <option v-for="tipo in tiposPendencias" :key="tipo.id" :value="tipo.id">
                                                {{ tipo.nome }}
                                            </option>
                                        </select>
                                    </div>

                                    <!-- Filtro por Prioridade -->
                                    <div>
                                        <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Prioridade</label>
                                        <select v-model="filtroPrioridade" class="w-full p-2.5 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg shadow-sm dark:text-white">
                                            <option value="">Todas</option>
                                            <option value="baixa">Baixa</option>
                                            <option value="media">Média</option>
                                            <option value="alta">Alta</option>
                                            <option value="critica">Crítica</option>
                                        </select>
                                    </div>

                                    <!-- Filtro por Responsável Interno -->
                                    <div>
                                        <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Responsável Interno</label>
                                        <select v-model="filtroResponsavelInterno" class="w-full p-2.5 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg shadow-sm dark:text-white">
                                            <option value="">Todos</option>
                                            <option v-for="resp in responsaveisInternos" :key="resp.id" :value="resp.id">
                                                {{ resp.nome_completo }}
                                            </option>
                                        </select>
                                    </div>

                                    <!-- Filtro por Responsável Externo -->
                                    <div>
                                        <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Responsável Externo</label>
                                        <select v-model="filtroResponsavelExterno" class="w-full p-2.5 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg shadow-sm dark:text-white">
                                            <option value="">Todos</option>
                                            <option v-for="fornecedor in fornecedores" :key="fornecedor.id" :value="fornecedor.id">
                                                {{ fornecedor.nome }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <!-- Botões -->
                                <div class="flex justify-between mt-6">
                                    <button @click="limparFiltros" class="px-6 py-2.5 bg-gray-500 text-white rounded-lg font-medium hover:bg-gray-600 transition-all">
                                        <i class="fas fa-filter-slash"></i> Limpar Filtros
                                    </button>
                                    <button @click="aplicarEFecarFiltro" class="px-6 py-2.5 bg-green-600 text-white rounded-lg font-medium hover:bg-green-700 transition-all">
                                        Aplicar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
            </div>
        </template>
    </BaseTemplate>
</template>

<script setup>
import { ref, onMounted, computed, watch, nextTick } from 'vue';
import { storeToRefs } from 'pinia'
import BaseTemplate from '@/views/templates/BaseTemplate.vue';
import { useRouter } from 'vue-router';
import { Filter, PlusCircle, RefreshCw, List, SquareKanban, Coins ,LucideClipboardList,
    LucideAlertCircle,
    LucideCheckCircle,
    InfoIcon } from 'lucide-vue-next'
import { usePendenciasStore } from '@/stores/pending/pendingStore'
import { useUserStore } from '@/stores/userStore'
import apiClient from '@/services/authService';
import PendenciasKanban from '@/views/pending/PendenciasKanban.vue';


const pendenciasStore = usePendenciasStore()
const userStore = useUserStore()

// Inicializar todas as refs importantes com valores padrão
const pendencias = ref([]);
const pendenciasFiltradas = ref([]);
const statusPendencias = ref([]);
const tiposPendencias = ref([]);
const unidades = ref([]);
const setores = ref([]);
const setoresFiltrados = ref([]);
const usuarios = ref([]);
const fornecedores = ref([]);
const modalCriarPendencia = ref(false);
const modalFiltro = ref(false);
const router = useRouter();
const responsaveisInternos = ref([]);
const isLoading = ref(true);


const totalPendencias = ref(0);
const atrasadas = ref(0);
const concluidas = ref(0);
const orcamentoTotal = ref(0);


// Configuração da paginação
const itensPorPagina = ref(10);
const paginaAtual = ref(1);

// Inicializar o total de itens como um ref local
const totalItems = ref(0);

// Calcular o total de páginas
const totalPaginas = computed(() => {
    return Math.ceil(totalItems.value / itensPorPagina.value);
});

// Determinar quais itens mostrar na página atual
const pendenciasPaginadas = computed(() => {
    // Garantir que pendenciasFiltradas.value existe e é um array
    if (!pendenciasFiltradas.value) return [];
    return pendenciasFiltradas.value;
});

// Removido o código de paginasVisiveis pois não é mais usado no novo estilo de paginação

// Função para mudar de página
const mudarPagina = (pagina) => {
    // Verifica se totalPaginas.value existe e se a página é válida
    if (pagina >= 1 && totalPaginas.value && pagina <= totalPaginas.value) {
        paginaAtual.value = pagina;
        carregarDados();
    }
};

const ordenarPor = (coluna) => {
    if (colunaOrdenada.value === coluna) {
        ordemAscendente.value = !ordemAscendente.value;
    } else {
        colunaOrdenada.value = coluna;
        ordemAscendente.value = true;
    }
    paginaAtual.value = 1;
    carregarDados();
};

// Função para alterar o número de itens por página
const alterarItensPorPagina = (novoValor) => {
    itensPorPagina.value = novoValor;
    paginaAtual.value = 1; // Volta para a primeira página ao mudar o número de itens
    carregarDados();
};



// ... 

const {
  filtroProblema,
  filtroStatus,
  filtroUnidade,
  filtroSetor,
  filtroTipo,
  filtroPrioridade,
  filtroResponsavelInterno,
  filtroResponsavelExterno,
  mostrarConcluidos,
  mostrarExcluidos,
  exibirKanban,
  totalFiltros,
} = storeToRefs(pendenciasStore)

// Função de filtragem
const aplicarFiltros = () => {
  // Filtra o array de pendências
  carregarDados();
};

// Monitorar mudanças nos filtros para atualizar os resultados automaticamente
watch([
  filtroStatus, 
  filtroUnidade, 
  filtroSetor, 
  filtroTipo, 
  filtroPrioridade, 
  filtroResponsavelInterno, 
  filtroResponsavelExterno, 
  mostrarConcluidos, 
  mostrarExcluidos
], () => {
    paginaAtual.value = 1;
    carregarDados();
});

// Função para buscar por problema
const buscarProblema = () => {
    paginaAtual.value = 1;
    carregarDados();
};

// Busca automática ao apagar o campo de busca
const onInputProblema = (event) => {
    if (!event.target.value || event.target.value.trim() === '') {
        paginaAtual.value = 1;
        carregarDados();
    }
};

// Função para aplicar os filtros e fechar o modal de filtro
const aplicarEFecarFiltro = () => {
    aplicarFiltros();
    fecharModalFiltro();
};

// Função para limpar todos os filtros
const limparFiltros = () => {
    pendenciasStore.limparFiltros();
    paginaAtual.value = 1;
    carregarDados();
};

// Função para abrir o modal e definir a pendência
const verDetalhes = (id) => {
    router.push({ name: "PendenciaDetalhes", params: { id } });
};

// Função para definir a classe CSS de prioridade
const getPrioridadeClass = (prioridade) => {
    const classes = {
        critica: "bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200",
        alta: "bg-orange-100 dark:bg-orange-900 text-orange-800 dark:text-orange-200",
        media: "bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200",
        baixa: "bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200"
    };
    return classes[prioridade] || "bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-200";
};

const irParaKanban = async () => {
  exibirKanban.value = !exibirKanban.value;

  // Aguarda próximo tick para garantir render
  await nextTick();

  // Atualiza a lista filtrada (caso tenha sido modificada em background)
  aplicarFiltros();
};


const novaPendencia = ref({
    unidade_id: '',
    setor_id: '',
    tipo_id: '',
    status: '', // valor inicial vazio
    responsavel_interno_id: '',
    responsavel_externo_id: '',
    problema: '',
    prazo: '',
    prazoPeriodo: '', // Novo campo para armazenar o período selecionado
    prioridade: 'media',
});

const isFormValid = computed(() => {
    return (
        novaPendencia.value.unidade_id &&
        novaPendencia.value.tipo_id &&
        novaPendencia.value.status &&
        novaPendencia.value.problema &&
        novaPendencia.value.prazoPeriodo &&
        novaPendencia.value.prazo &&
        novaPendencia.value.prioridade
    );
});

// Estado para armazenar a coluna atualmente ordenada e a direção (ascendente/descendente)
const colunaOrdenada = ref('id');
const ordemAscendente = ref(false);

// Computed property para status disponíveis baseado no tipo selecionado
const statusDisponiveis = computed(() => {
    if (!novaPendencia.value.tipo_id) return [];
    
    const tipoSelecionado = tiposPendencias.value.find(tipo => tipo.id === novaPendencia.value.tipo_id);
    return tipoSelecionado?.status_disponiveis || [];
});

// Função para calcular o prazo baseado no período selecionado
const calcularPrazo = () => {
    if (novaPendencia.value.prazoPeriodo) {
        const dias = parseInt(novaPendencia.value.prazoPeriodo, 10);
        const hoje = new Date();
        hoje.setDate(hoje.getDate() + dias);
        novaPendencia.value.prazo = hoje.toISOString().split('T')[0]; // Formata para yyyy-mm-dd
    }
};

// Buscar Dados
const carregarPendencias = async () => {
    try {
        const res = await apiClient.get('/api/v1/pending/');
        pendencias.value = res.data;
        pendenciasFiltradas.value = pendencias.value;
        aplicarFiltros(); // Aplica os filtros ao carregar

    } catch (error) {
        console.error("Erro ao buscar pendências:", error);
    }
};

// Formatar valores como dinheiro (R$ BRL)
const formatCurrency = (value) => {
    if (value === null || value === undefined || value === "") return "Não Informado";
    const numericValue = Number(value);
    if (isNaN(numericValue)) return "Não Informado";
    // Converte de centavos para reais dividindo por 100 e formata com o símbolo "R$"
    return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(numericValue / 100);
};

const formatarData = (data) => {
    if (!data) return "Sem data";
    return new Date(data).toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });
};


const carregarTiposPendencias = async () => {
    try {
        const res = await apiClient.get('/api/v1/pending/pending_types/');

        tiposPendencias.value = res.data.map(tipo => ({
            id: tipo.id,
            nome: tipo.nome,
            status_disponiveis: tipo.status_disponiveis || []  // Garante que o campo exista
        }));

    } catch (error) {
        console.error("Erro ao buscar tipos de pendências:", error);
    }
};

const carregarUnidades = async () => {
    try {
        const res = await apiClient.get('/api/v1/enterprises');
        unidades.value = res.data;
    } catch (error) {
        console.error("Erro ao buscar unidades:", error);
    }
};

// Buscar Usuários do Sistema
const carregarUsuarios = async () => {
    try {
        const res = await apiClient.get('/api/v1/auth/users/');
        usuarios.value = res.data.map(user => ({
            id: user.id,
            nome: user.first_name || user.nome,
            sobrenome: user.last_name || user.sobrenome
        }));
    } catch (error) {
        console.error("Erro ao buscar usuários:", error);
    }
};

const carregarFornecedores = async () => {
    try {
        const res = await apiClient.get('/api/v1/supplier/');
        let lista = Array.isArray(res.data.items) ? res.data.items : Array.isArray(res.data) ? res.data : [];
        // Garante que cada fornecedor tenha id e nome
        fornecedores.value = lista.map(f => ({
            id: Number(f.id),
            nome: f.nome || f.razao_social || f.fantasia || f.name || 'Fornecedor sem nome'
        }));
        console.log('Fornecedores carregados:', fornecedores.value);
    } catch (error) {
        fornecedores.value = [];
        console.error("Erro ao buscar fornecedores:", error);
    }
};

const carregarSetores = async () => {
    try {
        const res = await apiClient.get('/api/v1/pending/sectors');
        setores.value = res.data;
    } catch (error) {
        console.error("Erro ao buscar setores:", error);
    }
};

// Filtrar setores com base na unidade selecionada
const filtrarSetores = () => {
    if (!novaPendencia.value.unidade_id) {
        setoresFiltrados.value = [];
        return;
    }
    setoresFiltrados.value = setores.value.filter(setor => setor.unidade.id === novaPendencia.value.unidade_id);
};

const mensagemSucesso = ref("");

const criarPendencia = async () => {
    try {
        // Faz a requisição para criar a pendência
        const response = await apiClient.post('/api/v1/pending/create-pending/', {
            unidade_id: novaPendencia.value.unidade_id,
            setor_id: novaPendencia.value.setor_id || null,
            tipo_id: novaPendencia.value.tipo_id,
            status_id: novaPendencia.value.status,
            responsavel_interno_id: novaPendencia.value.responsavel_interno_id || null,
            responsavel_externo_id: novaPendencia.value.responsavel_externo_id || null,
            problema: novaPendencia.value.problema,
            prazo: novaPendencia.value.prazo,
            prioridade: novaPendencia.value.prioridade,
        });

        // Exibir mensagem de sucesso
        mensagemSucesso.value = "Pendência criada com sucesso!";

        setTimeout(() => {
            mensagemSucesso.value = "";
        }, 3000);

        // Fechar o modal
        modalCriarPendencia.value = false;

        // Atualizar a lista de pendências
        await carregarPendencias();

        // Redirecionar para a página de detalhes da pendência recém-criada
        const pendenciaId = response.data.id;  // Obtém o ID retornado pela API
        router.push({ name: "PendenciaDetalhes", params: { id: pendenciaId } });

    } catch (error) {
        console.error("Erro ao criar pendência:", error);
        alert("Erro ao criar pendência!");
    }
};

// Função para carregar os responsáveis internos
const carregarResponsaveisInternos = async () => {
    try {
        const response = await apiClient.get("/api/v1/responsible/");
        // Se a API retornar um objeto com a chave "items", usa esse array; caso contrário, usa a resposta direta.
        responsaveisInternos.value = response.data.items || response.data;
    } catch (error) {
        console.error("Erro ao carregar responsáveis internos:", error);
    }
};


// Carregar todos os dados com estado de carregamento
// Parâmetros de paginação e filtros



const carregarDados = async () => {
  isLoading.value = true;
  try {
    // Prepara os parâmetros para a API, removendo valores vazios
    const params = {
      page: paginaAtual.value,
      page_size: itensPorPagina.value,
      sort_by: colunaOrdenada.value,
      sort_dir: ordemAscendente.value ? 'asc' : 'desc',
    };
    
    // Adiciona filtros apenas se tiverem valores
    if (filtroProblema.value) params.problema = filtroProblema.value;
    if (filtroStatus.value) params.status = filtroStatus.value;
    if (filtroUnidade.value) params.unidade = filtroUnidade.value;
    if (filtroSetor.value) params.setor = filtroSetor.value;
    if (filtroTipo.value) params.tipo = filtroTipo.value;
    if (filtroPrioridade.value) params.prioridade = filtroPrioridade.value;
    if (filtroResponsavelInterno.value) params.responsavel_interno = filtroResponsavelInterno.value;
    if (filtroResponsavelExterno.value) params.responsavel_externo = filtroResponsavelExterno.value;
    
    // Sempre inclui os parâmetros de mostrar concluídos/excluídos
    params.mostrar_concluidos = mostrarConcluidos.value;
    params.mostrar_excluidos = mostrarExcluidos.value;
    
    console.log('Carregando dados com parâmetros:', params);
    const [
      pendenciasRes, statusRes, tiposRes, unidadesRes,
      setoresRes, usuariosRes
    ] = await Promise.all([
      apiClient.get('/api/v1/pending/', { params }),

    ]);

    pendencias.value = pendenciasRes.data.items;
    pendenciasFiltradas.value = pendenciasRes.data.items;
    totalItems.value = pendenciasRes.data.total;
// Se totalItens vier do store, use: pendenciasStore.totalItens.value = pendenciasRes.data.total;
    // Não chama mais aplicarFiltros();

    statusPendencias.value = statusRes.data;
    tiposPendencias.value = tiposRes.data;
    unidades.value = unidadesRes.data;
    setores.value = setoresRes.data;
    usuarios.value = usuariosRes.data;
    await carregarFornecedores();
  } catch (error) {
    console.error("Erro ao carregar os dados:", error);
  } finally {
    isLoading.value = false;
  }
};

// Função para buscar métricas
const carregarMetricas = async () => {
  const response = await apiClient.get("/api/v1/pending/metrics/");
  totalPendencias.value = response.data.total_pendencias;
  atrasadas.value = response.data.atrasadas;
  concluidas.value = response.data.concluidas;
  orcamentoTotal.value = formatCurrency(response.data.orcamento_total);
};


// Função para definir classe CSS do status
const getStatusClass = (status) => {
    if (status.startsWith("Aguardando")) {
        return 'bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200';
    }

    switch (status) {
        case 'Pendente':
            return 'bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200';
        case 'GLPI Aberto':
            return 'bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200';
        case 'Em Compras':
            return 'bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200';
        case 'Em andamento':
            return 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200';
        case 'Concluído':
            return 'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200';
        case 'Cancelado':
            return 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200';
        case 'Suspenso':
            return 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200';
        default:
            return 'bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-200';
    }
};


// Função para carregar os status das pendências
const carregarStatusPending = async () => {
    try {
        const response = await apiClient.get("/api/v1/pending/status_pending/");
        // Se a API retornar um objeto com a chave "items", usa esse array; caso contrário, usa a resposta direta.
        statusPendencias.value = response.data.items || response.data;
    } catch (error) {
        console.error("Erro ao carregar status das pendências:", error);
    }
};

const podeCriarPendencia = computed(() => {
    return userStore.grupos.includes('superadmin') || userStore.grupos.includes('direcao');
});

const mensagemSemPendencias = computed(() => {
    if (userStore.grupos.includes('superadmin')) {
        return 'Nenhuma pendência cadastrada. Clique abaixo para criar uma nova pendência.';
    } else if (userStore.grupos.includes('direcao')) {
        return 'Nenhuma pendência cadastrada. Clique abaixo para criar uma nova pendência.';
    } else {
        return 'Não há nenhuma pendência atribuída a você 🎉';
    }
});

// Verifica se há filtros ativos
const temFiltrosAtivos = computed(() => {
    return !!(
        (filtroProblema.value && filtroProblema.value.trim() !== '') ||
        filtroStatus.value ||
        filtroUnidade.value ||
        filtroSetor.value ||
        filtroTipo.value ||
        filtroPrioridade.value ||
        filtroResponsavelInterno.value ||
        filtroResponsavelExterno.value ||
        mostrarConcluidos.value === true ||
        mostrarExcluidos.value === true
    );
});

// Funções para abrir e fechar o modal de criar pendência
const abrirModalCriarPendencia = () => {
    modalCriarPendencia.value = true;
    carregarTiposPendencias();
    carregarUnidades();
    carregarUsuarios();
    carregarSetores();
    carregarResponsaveisInternos();
    carregarFornecedores();

};

const fecharModalCriarPendencia = () => {
    modalCriarPendencia.value = false;
};

// Funções para modal
const abrirModalFiltro = () => {
    modalFiltro.value = true;
    carregarTiposPendencias();
    carregarUnidades();
    carregarUsuarios();
    carregarSetores();
    carregarResponsaveisInternos();
    carregarFornecedores();
    carregarStatusPending();
};

const fecharModalFiltro = () => modalFiltro.value = false;


// Watch para limpar o status quando o tipo mudar
watch(() => novaPendencia.value.tipo_id, () => {
    novaPendencia.value.status = '';
});

onMounted(() => {
    carregarDados();
    carregarMetricas();
});
</script>
